import NavMenu from "../../../components/public/others/Navbar";
import NavMenuCM from "../../../components/public/others/NavbarCM";
import Footer from "../../../components/public/others/Footer";
import { useParams } from "react-router-dom";
import { TipoPortal } from "../../../services/variables";
import NewsContainer from "../../../components/public/news/NewsContainer";

export default function NewsPage() {
  const { idNoticias } = useParams();
  return (
    <>
      {TipoPortal == 3 ? (
        <>
          <NavMenu />
        </>
      ) : (
        <>
          <NavMenuCM />
        </>
      )}
      <NewsContainer idNews={idNoticias} />
      <Footer />
    </>
  );
}
